// extracted by mini-css-extract-plugin
export default {"dropZone":"DropZone_dropZone__52pZf","active":"DropZone_active__dBohi"};